module.exports = __webpack_public_path__ + "img/2.50692e7e.jpg";